import {  postRequest } from '@/libs/axios';
export const createNumberInterval = (params) => {
    return postRequest('/ndt/numberInterval/insert', params)
}

export const updateNumberInterval = (params) => {
    return postRequest('/ndt/numberInterval/update', params)
}

export const deleteNumberInterval = (params) => {
    return postRequest('/ndt/numberInterval/delete', params)
}
export const getNumberIntervalType = (params) => {
    return postRequest('/ndt/numberInterval/type', params)
}

export const getNumberIntervalList = (params) => {
    return postRequest('/ndt/numberInterval/list', params)
}
